import { useAppointmentSlotsByProviderQuery } from "~/services/scheduling";

export const useGetProvidersSlots = useAppointmentSlotsByProviderQuery;
